module.exports = __webpack_public_path__ + "static/media/why_toyota_bg.41056ccb.jpg";